import React from 'react'
import { ValueToModel } from '@morningtrain/react-resources'
import AvgBasketSizeTable from 'pages/app/economy/partials/AvgBasketSizeTable'
import WhenMultipleDepartmentsAreSelected from 'support/conditionals/WhenMultipleDepartmentsAreSelected'
import {Env} from "@morningtrain/helpers";
import AvgBasketSizeTableCalculatedDepartment from "pages/app/economy/partials/AvgBasketSizeTableCalculatedDepartment";
import AvgBasketSizeTableCalculatedEmployee from "pages/app/economy/partials/AvgBasketSizeTableCalculatedEmployee";

export default function AvgBasketSizeTables () {
  const hasCalculatedBasketSize = Env.get('globals.has_calculated_basket_size');
  return (
    <>
      <WhenMultipleDepartmentsAreSelected>
        <ValueToModel name='table.1'>
          { hasCalculatedBasketSize ? <AvgBasketSizeTableCalculatedDepartment mode='departments' />
            : <AvgBasketSizeTable mode='departments' />
          }
        </ValueToModel>
      </WhenMultipleDepartmentsAreSelected>
      <ValueToModel name='table.0'>
        { hasCalculatedBasketSize ? <AvgBasketSizeTableCalculatedEmployee mode='employees' />
          : <AvgBasketSizeTable mode='employees' />
        }
      </ValueToModel>
    </>
  )
}
